import * as s from "react";
import o from "../lib/IconBase.es.js";
import e from "../defs/MagnifyingGlassMinus.es.js";
const n = s.forwardRef((a, i) => /* @__PURE__ */ s.createElement(o, { ref: i, ...a, weights: e }));
n.displayName = "MagnifyingGlassMinusIcon";
const f = n;
export {
  f as MagnifyingGlassMinus,
  n as MagnifyingGlassMinusIcon
};
